import { apiClient } from './apiClient';

import type { EmailCategoriesResponse } from '@/types/emailPreference.types';

// Token-based (public, no auth required)

export async function getPreferencesByToken(token: string): Promise<EmailCategoriesResponse> {
  const res = await fetch(`/api/notifications/preferences/by-token/${encodeURIComponent(token)}`);

  if (!res.ok) {
    throw new Error('Failed to load preferences');
  }

  return res.json() as Promise<EmailCategoriesResponse>;
}

export async function updatePreferenceByToken(token: string, category: string, optedOut: boolean): Promise<void> {
  const res = await fetch(`/api/notifications/preferences/by-token/${encodeURIComponent(token)}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ category, optedOut }),
  });

  if (!res.ok) {
    throw new Error('Failed to update preference');
  }
}

// Auth-based (JWT, for logged-in users)

export function getPreferencesAuthenticated(): Promise<EmailCategoriesResponse> {
  return apiClient.get<EmailCategoriesResponse>('/notifications/preferences');
}

export async function updatePreferenceAuthenticated(
  channel: string,
  category: string,
  optedOut: boolean,
): Promise<void> {
  await apiClient.put('/notifications/preferences', { channel, category, optedOut });
}
